<template>
	<v-tab-item>
		<v-sheet elevation="0" class="pa-2">
			<h3 class="text-h6 font-weight-bold">使用見込み製品(受注時)</h3>
			<p class="mt-4">ゴム生地名 : {{ rubber.name }}</p>
			<div class="table-container mt-2">
				<v-data-table
					locale="ja-JP"
					:headers="headers"
					:items="receiving_shippings"
					item-key="name"
					class="elevation-1"
					:mobile-breakpoint="240"
					disable-filtering
					disable-pagination
					disable-sort
					hide-default-footer
					no-data-text="データがありません。"
				>
					<template v-slot:item="{ item }">
						<tr>
							<td>
								{{ item.order_target.order_individual_info.get_product_number_with_sub_number }}
							</td>
							<td>
								{{ item.order_target.order_individual_info.ordered_product.product.name }}
							</td>
							<td>
								{{ item.order_target.order_individual_info.ordered_product.quantity }}
							</td>
							<td>
								{{ common.formatDate(item.planned_operation_date) }}
							</td>
							<td>
								{{ item.planned_quantity }}
							</td>
						</tr>
					</template>
				</v-data-table>
			</div>
		</v-sheet>

		<PaginationModule :pagination="pagination" @get-page="getPage($event)" />
	</v-tab-item>
</template>

<script>
import axios from "axios"
import authenticate from "../../../helper/authenticate"
import errorHandling from "../../../helper/errorHandling"
import PaginationModule from "../../shared/PaginationModule.vue"
import common from "../../../helper/common"

export default {
	props: {
		rubber: {
			type: Object,
			default: false,
		},
		isFetched: {
			type: Boolean,
		},
	},
	components: {
		PaginationModule,
	},
	data() {
		return {
			headers: [
				{ text: "製番(枝番込み)", width: "100px" },
				{ text: "製品名", width: "100px" },
				{ text: "製品個数", width: "50px" },
				{ text: "出庫予定日", width: "80px" },
				{ text: "出庫予定", width: "50px" },
			],
			pagination: {
				count: null,
				current: 1,
				limit_value: null,
				next: null,
				pages: null,
				previous: null,
			},
			rubber_order_individual_infos: [],
			receiving_shippings: [],
			common,
		}
	},
	methods: {
		fetchRubberCustomerCompanies(i) {
			const headers = authenticate.setHeader()
			const url = `/erp/v1/rubber/receiving_shippings`
			axios
				.get(url, {
					headers,
					params: {
						page: i,
						rubber_id: this.rubber.id,
					},
				})
				.then((res) => {
					this.receiving_shippings = res.data.receiving_shippings
					this.pagination = res.data.pagination
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		getPage(i) {
			this.fetchRubberCustomerCompanies(i)
			const elements = document.getElementsByClassName("v-dialog--active")
			if (!elements || !elements.length) {
				return
			}
			elements[0].scrollTop = 0
		},
	},
	watch: {
		isFetched(newVal, oldVal) {
			if (oldVal == false && newVal == true) {
				this.fetchRubberCustomerCompanies(1)
			} else if (oldVal == true && newVal == false) {
			}
		},
		deep: true,
	},
}
</script>

<style scoped lang="scss">
.table-container {
	td {
		cursor: auto !important;
	}
}
</style>
